import React from 'react'
import styled from 'styled-components'
import contactPoints from './contact-points'
import Hero from './components/Hero'
import Grid from './components/Grid'
import Actions from './components/Actions'
import ExpiredWarning from './components/ExpiredWarning'

class App extends React.Component	
	render: ()->
		{card} = @props
		childProps = {color:card.color, demo:card.demo}
		
		if not card.demo and card['@expire'] and Date.create() > Date.create(card['@expire'])
			return <ExpiredWarning {childProps...} />
		
		<div>
			<Hero card={card} {childProps...} />
			<Grid card={card} points={card.contactPoints} {childProps...} />
			<Actions card={card} labels={card.buttonLabels} {childProps...} />
		</div>





export default App